export default {"src":"/_next/static/image/public/images/ic_rx_grey.c390f0ab6bdc8342f6b788cdf7041e18.svg","height":19,"width":16};